import React, { useEffect, useState } from "react";
import { fetchCmsContent } from "../services/fetchCmsContent";
import MainPageComponents from "../components/CommonComponents/MainPageComponents";

interface NewsItem {
  title: string;
  slug: string;
  content: string;
  updated_at: string;
}

const NewsUpdatesPage: React.FC = () => {
  const [news, setNews] = useState<NewsItem | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchCmsContent("News & Updates", "/api/cms/news-updates", setNews, setLoading);
  }, []);

  return (
    <MainPageComponents
      title={news?.title || "News And Updates"}
      content={news?.content || ""}
      loading={loading}
      updated_at={news?.updated_at || ""}
    />);
};

export default NewsUpdatesPage;
